import { DiamondLogo } from 'ui/logo';
import { Telnyx, Twilio, Dyn, SendGrid, Mailgun, SparkPost, WhatsApp } from 'ui/thirdPartyLogos';
import { CustomEmail, CustomPush } from 'ui/illustrations';
import { SENDING_PLATFORM_CATEGORIES } from '../types';
import {
  DYN,
  ITERABLE,
  ITERABLE_SMS,
  MAILGUN,
  SENDGRID,
  SPARKPOST,
  TELNYX,
  TWILIO,
  CUSTOM_EMAIL,
  CUSTOM_PUSH,
  WHATS_APP,
} from './sendingPlatforms';

export const SENDING_PLATFORMS_METADATA = {
  [ITERABLE]: {
    name: 'Iterable',
    id: ITERABLE,
    indexDescription: 'Iterable can connect you to a shared Amazon SES pool.',
    editDescription:
      'Iterable can connect you to a shared Amazon SES pool. Shared IPs will have other senders that will use the same IP address. If you want to setup dedicated IP pools talk to your CSM about alternate sending platforms. ',
    supportLink: 'https://support.iterable.com/hc/en-us/articles/208246613-Shared-vs-Dedicated-IPs',
    partnerLink: undefined,
    category: SENDING_PLATFORM_CATEGORIES.EMAIL,
    logoSvg: DiamondLogo,
  },
  [ITERABLE_SMS]: {
    name: 'Iterable SMS',
    id: ITERABLE_SMS,
    indexDescription: 'Use Iterable to send marketing and transactional SMS messages.',
    editDescription: 'Use Iterable to send marketing and transactional SMS messages.',
    supportLink: '',
    partnerLink: undefined,
    category: SENDING_PLATFORM_CATEGORIES.SMS,
    logoSvg: DiamondLogo,
  },
  [MAILGUN]: {
    name: 'MailGun',
    id: MAILGUN,
    indexDescription:
      'Developer-focused, email delivery platform that empowers companies to send, receive, and track emails.',
    editDescription:
      'Mailgun is a developer-focused, email delivery platform that empowers companies to send, receive, and track transactional and marketing emails through an API.',
    supportLink:
      'https://support.iterable.com/hc/en-us/articles/360021284071-Integrating-Mailgun-with-Iterable',
    partnerLink: 'https://www.mailgun.com',
    category: SENDING_PLATFORM_CATEGORIES.EMAIL,
    logoSvg: Mailgun,
  },
  [DYN]: {
    name: 'Dyn',
    id: DYN,
    indexDescription:
      'Leverage best-in-class DNS, Web Application Security, and Email Delivery services within Oracle Cloud Infrastructure.',
    editDescription:
      "Enterprises can leverage the best-in-class DNS, Web Application Security, and Email Delivery services within Oracle Cloud Infrastructure built on Oracle Dyn's proven technology.",
    supportLink:
      'https://support.iterable.com/hc/en-us/articles/360016368391-Using-Dyn-with-Iterable',
    partnerLink: 'https://account.dyn.com',
    category: SENDING_PLATFORM_CATEGORIES.EMAIL,
    logoSvg: Dyn,
  },
  [SENDGRID]: {
    name: 'SendGrid',
    id: SENDGRID,
    indexDescription:
      'Create an exceptional email program with the Email API trusted by top brands to deliver at scale.',
    editDescription:
      'SendGrid creates an exceptional email program with the Email API trusted by top brands to deliver at scale.',
    supportLink:
      'https://support.iterable.com/hc/en-us/articles/360024893352-Integrating-Sendgrid-with-Iterable',
    partnerLink: 'https://sendgrid.com/solutions/email-api/',
    category: SENDING_PLATFORM_CATEGORIES.EMAIL,
    logoSvg: SendGrid,
  },
  [SPARKPOST]: {
    name: 'SparkPost',
    id: SPARKPOST,
    indexDescription:
      'Optimize your email program with world class email expertise and real-time data.',
    editDescription:
      'SparkPost has empowered companies to optimize their email program by providing them with world class email expertise and real-time data at their fingertips.',
    supportLink:
      'https://support.iterable.com/hc/en-us/articles/360016366151-Integrating-Sparkpost-with-Iterable',
    partnerLink: 'https://www.sparkpost.com/features/email-api-integration/',
    category: SENDING_PLATFORM_CATEGORIES.EMAIL,
    logoSvg: SparkPost,
  },
  [TELNYX]: {
    name: 'Telnyx',
    id: TELNYX,
    indexDescription:
      'Reach users at scale wherever they are in the world, with triggered SMS alerts.',
    editDescription:
      'Telnyx reaches users at scale wherever they are in the world, with triggered SMS alerts to keep them informed when it counts.',
    supportLink:
      'https://support.iterable.com/hc/en-us/articles/6265788025236-Integrating-Telnyx-with-Iterable-',
    partnerLink: 'https://telnyx.com/products/programmable-sms',
    category: SENDING_PLATFORM_CATEGORIES.SMS,
    logoSvg: Telnyx,
  },
  [TWILIO]: {
    name: 'Twilio',
    id: TWILIO,
    indexDescription: 'Send notifications, alerts, and marketing messages with one API.',
    editDescription:
      'Twilio sends notifications, alerts, and marketing messages with one API that has software for managing phone numbers, deliverability, compliance, and replies.',
    supportLink:
      'https://support.iterable.com/hc/en-us/articles/360016153612-Integrating-Twilio-with-Iterable',
    partnerLink: 'https://www.twilio.com',
    category: SENDING_PLATFORM_CATEGORIES.SMS,
    logoSvg: Twilio,
  },
  [WHATS_APP]: {
    name: 'WhatsApp',
    id: 'whatsApp',
    indexDescription:
      'Connect your WhatsApp Business account in Meta to engage with customers globally.',
    editDescription:
      'Connect your WhatsApp Business account in Meta to engage with customers globally.',
    supportLink: '',
    // TODO: get correct support link
    partnerLink: 'https://developers.facebook.com/docs/whatsapp',
    category: SENDING_PLATFORM_CATEGORIES.WHATS_APP,
    logoSvg: WhatsApp,
  },
  [CUSTOM_EMAIL]: {
    name: 'Custom email platform',
    id: CUSTOM_EMAIL,
    indexDescription:
      'Use your own infrastructure to manage the final processing and sending of messages.',
    editDescription:
      'Use your own infrastructure to manage the final processing and sending of messages.',
    supportLink: 'https://support.iterable.com',
    partnerLink: '',
    category: SENDING_PLATFORM_CATEGORIES.EMAIL,
    logoSvg: CustomEmail,
  },
  [CUSTOM_PUSH]: {
    name: 'Custom push platform',
    id: CUSTOM_PUSH,
    indexDescription:
      'Use your own infrastructure to manage the final processing and sending of messages.',
    editDescription:
      'Use your own infrastructure to manage the final processing and sending of messages.',
    supportLink: 'https://support.iterable.com',
    partnerLink: '',
    category: SENDING_PLATFORM_CATEGORIES.PUSH,
    logoSvg: CustomPush,
  },
};
